t = require('views/internal/teacup-with-helpers')('board_menu_default')

module.exports = t.renderable ({ canAssign, canInviteMembers, canJoin, selfJoin,
  canChangeBackground, canEnablePowerUps, hasBCPowerUps, hasGoldPowerUps,
  useTabs, highlightAddMember, org, hasOrg, visibility, canChangeOrganization }) ->

  t.p '.error.js-file-too-large', { style: 'margin: 12px 0 6px; display:none;' }, ->
    t.format 'file-too-large-10mb-limit'

  if useTabs
    t.div '.board-menu-visibility', ->
      t.div '.board-menu-visibility-organization', {
        class: t.classify({
          'board-menu-visibility-organization-editable': canChangeOrganization
          'js-change-organization': canChangeOrganization
        })
      }, ->
        if org?
          if org.logoHash?
            orgLogoUrl1x = "#{window.logoDomain}/#{org.logoHash}/30.png"
            orgLogoUrl2x = "#{window.logoDomain}/#{org.logoHash}/170.png"

            t.div '.board-menu-visibility-logo', ->
              t.img '.board-menu-visibility-logo-image',
                src: orgLogoUrl1x
                srcSet: "#{orgLogoUrl1x} 1x, #{orgLogoUrl2x} 2x"

          t.div '.board-menu-visibility-display-name', { title: org.displayName }, ->
            t.text org.displayName

          t.div '.board-menu-visibility-icon', ->
            if org.hasEnterprise
              t.icon 'enterprise'
            else if org.isBusinessClass
              t.icon 'business-class'
        else
          t.div '.board-menu-visibility-display-name', ->
            if hasOrg
              t.format 'team-board'
            else
              t.format 'personal-board'

      t.div '.board-menu-visibility-gap'

      t.div '.board-menu-visibility-permission-level.quiet.js-change-visibility', ->
        switch visibility
          when 'public'
            t.icon 'public'
            t.format 'public'
          when 'org'
            t.icon 'organization-visible'
            t.format 'team-visible'
          when 'private'
            t.icon 'private'
            t.format 'private'

  if useTabs
    if canInviteMembers
      t.div '.highlight-add-members.js-highlight-add-members', ->
        t.div '.highlight-add-members-close.js-close-highlight-add-members', ->
          t.icon 'close'
        t.div '.highlight-add-members-description', ->
          t.format 'put-more-brainpower-behind-your-project'

        t.a '.button-link.primary.js-open-manage-board-members', { href: '#' }, ->
          t.icon 'add-member', 'invite-ellipsis'

      t.a '.button-link.mod-full.js-simple-add-members.js-open-manage-board-members', { href: '#' }, ->
        t.icon 'add-member', 'invite-ellipsis'

    if canJoin
      t.a '.button-link.js-join-board', { href: '#', style: 'margin-bottom: 0;' }, ->
        t.icon 'add-member', 'join-board'

      if selfJoin
        t.p '.helper', { style: 'margin-top: 8px;' }, ->
          t.format 'org-members-can-join-this-board'

    if canInviteMembers || canJoin
      t.div { style: 'height: 16px' }

  sections = [
    { key: "members", jsClass: 'js-list-members' }
    { key: "team-members", jsClass: 'js-list-team-members' }
    { key: "invited-members", jsClass: 'js-list-invited-members' }
    { key: "non-team-members", jsClass: 'js-list-non-team-members' }
    { key: "observers", jsClass: 'js-list-observers' }
    { key: "deactivated-members", jsClass: 'js-deactivated-members' }
  ]

  t.div '.js-all-members', ->
    if useTabs
      t.h3 ->
        t.format 'members'

    for { key, jsClass } in sections
      t.div ".board-menu-member-section.#{ jsClass }", ->
        t.div '.board-menu-member-section-header.js-heading', ->
          t.format key

        t.div '.u-clearfix.js-list', { class: t.classify('js-list-draggable-board-members': canAssign) }

  if !useTabs
    t.div '.board-members-extras-button.u-clearfix.js-show-extra-members-button', ->
      t.a '.quiet-button.js-show-extra-members', { href: '#' }, ->
        t.format 'show-hidden-members'

    t.div '.board-members-extras-button.u-clearfix.js-hide-extra-members-button', ->
      t.a '.quiet-button.js-hide-extra-members', { href: '#' }, ->
        t.format 'show-fewer-members'

  if !useTabs
    if canInviteMembers
      t.a '.button-link.mod-full.js-simple-add-members.js-open-manage-board-members', { href: '#' }, ->
        t.icon 'add-member', 'invite-ellipsis'

    if canJoin
      t.a '.button-link.js-join-board', { href: '#', style: 'margin-bottom: 0;' }, ->
        t.icon 'add-member', 'join-board'

      if selfJoin
        t.p '.helper', { style: 'margin-top: 8px;' }, ->
          t.format 'org-members-can-join-this-board'

  if !useTabs
    t.hr()

    t.ul '.board-menu-navigation', ->

      if canChangeBackground
        t.li '.board-menu-navigation-item.mod-background', ->
          t.a '.board-menu-navigation-item-link.js-change-background', { href: '#' }, ->
            t.span '.board-menu-navigation-item-link-icon.js-fill-background-preview'
            t.raw '&nbsp;'
            t.format 'change-background'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-card-filter', { href: '#' }, ->
          t.icon 'filter', 'filter-cards', { class: 'board-menu-navigation-item-link-icon' }

      if canEnablePowerUps
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-open-power-ups', { href: '#' }, ->
            t.icon 'power-up', 'power-ups', { class: 'board-menu-navigation-item-link-icon' }
            t.raw '&nbsp;'
            if hasBCPowerUps
              t.icon 'business-class', class: 'icon-business-class-color'
            else if hasGoldPowerUps
              t.icon 'trello-gold', { class: 'icon-trello-gold-color' }
            t.span '.board-menu-navigation-item-link-count.js-enabled-power-up-count'
            t.span '.board-menu-navigation-item-new.js-power-up-new', ->
              t.format 'new'
            t.span '.board-menu-navigation-item-link-warning.js-power-up-disable-timer'
            t.div '.board-menu-navigation-item-link-summary', ->
              t.raw '&nbsp;'
              t.format 'power-ups-explanation'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-stickers', { href: '#' }, ->
          t.icon 'sticker', 'stickers', { class: 'board-menu-navigation-item-link-icon' }

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-more', { href: '#' }, ->
          t.icon 'overflow-menu-horizontal', 'more', { class: 'board-menu-navigation-item-link-icon' }

    t.hr()

    t.a '.board-menu-section-header.js-open-activity', { href: '#' }, ->
      t.span '.board-menu-section-header-icon.icon-lg.icon-activity'
      t.span '.board-menu-section-header-title', ->
        t.format 'activity'
      t.span '.board-menu-section-header-count.js-unread-activity-count'

    t.div '.js-menu-action-list'

    t.a '.show-more.js-fill-activity-button.js-open-activity', { href: '#' }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_default.coffee